export class JobSnapshotDetails {
    'id';
    'pointInTime';
    'expirationTime';
    'backupRetention';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "pointInTime",
            "baseName": "pointInTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "expirationTime",
            "baseName": "expirationTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "backupRetention",
            "baseName": "backupRetention",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return JobSnapshotDetails.attributeTypeMap;
    }
    constructor() {
    }
}
